import React from 'react'
import icon_1 from "assets/images/specialties/1.png";
import icon_2 from "assets/images/specialties/2.png";
import icon_3 from "assets/images/specialties/3.png";
import icon_4 from "assets/images/specialties/4.png";
import icon_5 from "assets/images/specialties/5.png";
import icon_6 from "assets/images/specialties/6.png";
import icon_7 from "assets/images/specialties/7.png";
import icon_8 from "assets/images/specialties/8.png";
import icon_9 from "assets/images/specialties/9.png";
import icon_10 from "assets/images/specialties/10.png";
import icon_11 from "assets/images/specialties/11.png";
import icon_12 from "assets/images/specialties/12.png";

export default function TopSearchSpecialties() {
    return (
        <div className='top-searched-specialties'>
            <h2 className='nex-text-xl nex-color-dark-blue'>Top-searched specialties</h2>
            <div className="top-searched-spec-items">
                <div className="top-searched-spec-item">
                    <div className="graphic">
                        <img src={icon_1} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Dentistry</h3>
                        <p>46 specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item">
                    <div className="graphic">
                        <img src={icon_2} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Primary care</h3>
                        <p>6 specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item">
                    <div className="graphic">
                        <img src={icon_3} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Cardiology</h3>
                        <p>46 specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item">
                    <div className="graphic">
                        <img src={icon_4} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Gastroenterology</h3>
                        <p>46 specialists</p>
                    </div>
                </div>


                <div className="top-searched-spec-item">
                    <div className="graphic">
                        <img src={icon_5} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Pediatrician</h3>
                        <p>46 specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item">
                    <div className="graphic">
                        <img src={icon_6} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Psychiatry</h3>
                        <p>6 specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item">
                    <div className="graphic">
                        <img src={icon_7} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Dermatology</h3>
                        <p>46 specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item">
                    <div className="graphic">
                    <img src={icon_8} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Diabetology</h3>
                        <p>46 specialists</p>
                    </div>
                </div>


                <div className="top-searched-spec-item">
                    <div className="graphic">
                        <img src={icon_9} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Physiotherapy</h3>
                        <p>46 specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item">
                    <div className="graphic">
                    <img src={icon_10} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Orthopaedics</h3>
                        <p>6 specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item">
                    <div className="graphic">
                    <img src={icon_11} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Gynecology</h3>
                        <p>46 specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item">
                    <div className="graphic">
                    <img src={icon_12} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Oncology</h3>
                        <p>46 specialists</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
